module.exports = __webpack_public_path__ + "static/media/social3.eba41513.svg";